import { toString as queryfilterToString } from '@gonfalon/queryfilter/builder';

import type { UIContextsView } from '../types/types';

export function serializeUIContextsViewForBrowser(ui: UIContextsView) {
  const searchParams = new URLSearchParams();

  if (ui.filter) {
    searchParams.set('filter', encodeURIComponent(queryfilterToString(ui.filter)));
  }

  return searchParams;
}
